export const GROUNDED_QA_DISCARD_MESSAGE = 'The answer being prepared will be discarded.';
export const GROUNDED_QA_POLL_INTERVAL_MS = 1500;

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/ai/useCases/groundedQa/dtos/groundedQa.dto.ts
export const GROUNDED_QA_PROMPT_MAX_CHARS = 10_000;

export const GROUNDED_QA_PLACEHOLDER_QUESTIONS = [
  'Which clinical use can be claimed and what should we explicitly not claim?',
  'Is there any new data that could change the benefit-risk conclusion?',
  'How is this device classified under the MDR?',
  'Are the claims in this document backed by evidence?',
  'What is the intended use of this device?',
  'What does the safety profile look like?',
];

export const GROUNDED_QA_UNKNOWN_SOURCE_LABEL = 'Unknown';

export const GROUNDED_QA_NO_SOURCES_CAPTION = 'No sources cited.';
